import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import InfoField from "./InfoField";
import { formatDisplayDate } from "../utility/utils";

const AssignmentDetailsSection = ({ assignment }) => {
	if (!assignment) return null;

	return (
		<Box sx={{ p: 1 }}>
			<Typography
				variant="h6"
				sx={{
					mb: 2,
					color: "primary.main",
					fontWeight: "medium",
				}}
			>
				Basic Information
			</Typography>

			{/* Assignment Details */}
			<Box sx={{ mb: 2 }}>
				<Typography
					variant="subtitle2"
					sx={{
						mb: 2,
						color: "text.primary",
					}}
				>
					Assignment Details
				</Typography>
				<Grid2 container spacing={1}>
					<InfoField
						label="Claim Number"
						value={assignment.claimNumber}
						size={4}
					/>
					<InfoField
						label="Policy Number"
						value={assignment.policyNumber}
						size={4}
					/>
					<InfoField
						label="Branch"
						value={assignment.branch}
						size={2}
					/>
					<InfoField label="Type" value={assignment.type} size={2} />
					<InfoField label="Mode" value={assignment.mode} size={2} />
					<InfoField
						label="Nature of Loss"
						value={assignment.natureOfLoss}
						size={2}
					/>
					<InfoField
						label="Insurance Company"
						value={assignment.insuranceCompany}
						size={8}
					/>
				</Grid2>
			</Box>

			{/* Important Dates */}
			<Box sx={{ mb: 2 }}>
				<Typography
					variant="subtitle2"
					sx={{
						mb: 2,
						color: "text.primary",
					}}
				>
					Important Dates
				</Typography>
				<Grid2 container spacing={1}>
					<InfoField
						label="Date of Loss"
						value={formatDisplayDate(assignment.dateOfLoss)}
						size={4}
					/>
					<InfoField
						label="Assignment Received"
						value={formatDisplayDate(assignment.assignmentReceived)}
						size={4}
					/>
					<InfoField
						label="Date of Survey"
						value={formatDisplayDate(assignment.dateOfSurvey)}
						size={4}
					/>
				</Grid2>
			</Box>

			{/* Contact Information */}
			<Box sx={{ mb: 2 }}>
				<Typography
					variant="subtitle2"
					sx={{
						mb: 2,
						color: "text.primary",
					}}
				>
					Contact Information
				</Typography>
				<Grid2 container spacing={1}>
					{assignment.claimants.map((insuredInfo, index) => (
						<React.Fragment key={index}>
							<InfoField
								label={`${
									insuredInfo.isPrimary ? "Primary-" : ""
								} Insured Name`}
								value={insuredInfo.insuredName}
								size={6}
							/>
							<InfoField
								label={`${
									insuredInfo.isPrimary ? "Primary-" : ""
								} Insured Contact`}
								value={insuredInfo.insuredContactDetails}
								size={6}
							/>
						</React.Fragment>
					))}

					<InfoField
						label="Address"
						value={assignment.address}
						size={12}
						multiline
					/>
					<InfoField
						label="Broker/Agent Details"
						value={assignment.brokersOrInsurerInvolved}
						size={4}
					/>
				</Grid2>
			</Box>
		</Box>
	);
};

export default AssignmentDetailsSection;
